var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "19px",
    viewBox: "0 0 15 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D4B98BE6-4CE3-42CC-9B8E-7C7375A4F6BF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Case-Page---",
    transform: "translate(-21.000000, -681.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(-1.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-2",
    transform: "translate(0.000000, 583.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "portable-document-format",
    transform: "translate(22.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.03760152,4.60227273 C2.03760152,2.81659091 3.4849778,1.36363636 5.26380392,1.36363636 L11.4669421,1.36363636 C11.2434852,0.578863636 10.5310039,0 9.67860722,0 L1.86780139,0 C0.837454224,0 0,0.840681818 0,1.875 L0,12.4431818 C0,13.4775 0.837454224,14.3181818 1.86780139,14.3181818 L2.03760152,14.3181818 L2.03760152,4.60227273 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125,2.72727273 L5.28409091,2.72727273 C4.24977273,2.72727273 3.40909091,3.56795455 3.40909091,4.60227273 L3.40909091,14.4886364 C3.40909091,15.5229545 4.24977273,16.3636364 5.28409091,16.3636364 L13.125,16.3636364 C14.1593182,16.3636364 15,15.5229545 15,14.4886364 L15,4.60227273 C15,3.56795455 14.1593182,2.72727273 13.125,2.72727273 Z M11.7613636,14.3181818 L6.64772727,14.3181818 C6.36545455,14.3181818 6.13636364,14.0890909 6.13636364,13.8068182 C6.13636364,13.5245455 6.36545455,13.2954545 6.64772727,13.2954545 L11.7613636,13.2954545 C12.0436364,13.2954545 12.2727273,13.5245455 12.2727273,13.8068182 C12.2727273,14.0890909 12.0436364,14.3181818 11.7613636,14.3181818 Z M11.7613636,11.5909091 L6.64772727,11.5909091 C6.36545455,11.5909091 6.13636364,11.3618182 6.13636364,11.0795455 C6.13636364,10.7972727 6.36545455,10.5681818 6.64772727,10.5681818 L11.7613636,10.5681818 C12.0436364,10.5681818 12.2727273,10.7972727 12.2727273,11.0795455 C12.2727273,11.3618182 12.0436364,11.5909091 11.7613636,11.5909091 Z M11.7613636,9.20454545 L6.64772727,9.20454545 C6.36545455,9.20454545 6.13636364,8.97545455 6.13636364,8.69318182 C6.13636364,8.41090909 6.36545455,8.18181818 6.64772727,8.18181818 L11.7613636,8.18181818 C12.0436364,8.18181818 12.2727273,8.41090909 12.2727273,8.69318182 C12.2727273,8.97545455 12.0436364,9.20454545 11.7613636,9.20454545 Z M11.7613636,6.47727273 L6.64772727,6.47727273 C6.36545455,6.47727273 6.13636364,6.24818182 6.13636364,5.96590909 C6.13636364,5.68363636 6.36545455,5.45454545 6.64772727,5.45454545 L11.7613636,5.45454545 C12.0436364,5.45454545 12.2727273,5.68363636 12.2727273,5.96590909 C12.2727273,6.24818182 12.0436364,6.47727273 11.7613636,6.47727273 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.8f28bbf4160a4f93e379ab3a3c011682.svg";
export { ForwardRef as ReactComponent };